<template>
  <div>
    <div v-if="ready">
      <form>
        <div class="mdi-card full-width q-pa-md">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <!-- TODO: Filter for Company > Member > Member Type -->
              <q-field
                orientation="vertical"
                label="Member Type"
                class="q-pa-md"
                v-if="selectOptions && selectOptions.memberTypes && selectOptions.memberTypes.length"
              >
                <q-select
                  multiple
                  v-model="form.memberTypes"
                  :options="selectOptions.memberTypes"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="inputBgColor"
                  filter
                  autofocus-filter
                  :display-value="form.memberTypes.length ? `` : `Any / All`"
                />
              </q-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <!-- TODO: Filter for Company > Company_Division > Division -->
              <q-field
                orientation="vertical"
                label="Division"
                class="q-pa-md"
                v-if="selectOptions && selectOptions.divisions && selectOptions.divisions.length"
              >
                <q-select
                  multiple
                  v-model="form.divisions"
                  :options="selectOptions.divisions"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="inputBgColor"
                  filter
                  autofocus-filter
                  :display-value="form.divisions.length ? `` : `Any / All`"
                />
              </q-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <!-- TODO: Filter for MN Senate District (all addresses)  -->
              <q-field
                orientation="vertical"
                label="MN Senate District"
                class="q-pa-md"
                v-if="selectOptions && selectOptions.mnSenateDistricts && selectOptions.mnSenateDistricts.length"
              >
                <q-select
                  multiple
                  v-model="form.mnSenateDistricts"
                  :options="selectOptions.mnSenateDistricts"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="inputBgColor"
                  filter
                  autofocus-filter
                  :display-value="form.mnSenateDistricts.length ? `` : `Any / All`"
                />
              </q-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <!-- TODO: Filter for MN House District (all addresses) -->
              <q-field
                orientation="vertical"
                label="MN House District"
                class="q-pa-md"
                v-if="selectOptions && selectOptions.mnHouseDistricts && selectOptions.mnHouseDistricts.length"
              >
                <q-select
                  multiple
                  v-model="form.mnHouseDistricts"
                  :options="selectOptions.mnHouseDistricts"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="inputBgColor"
                  filter
                  autofocus-filter
                  :display-value="form.mnHouseDistricts.length ? `` : `Any / All`"
                />
              </q-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <!-- TODO: Filter for US Congressional District (all addresses)   -->
              <q-field
                orientation="vertical"
                label="US Congressional District"
                class="q-pa-md"
                v-if="selectOptions && selectOptions.mnUsCongressionalDistricts && selectOptions.mnUsCongressionalDistricts.length"
              >
                <q-select
                  multiple
                  v-model="form.mnUsCongressionalDistricts"
                  :options="selectOptions.mnUsCongressionalDistricts"
                  class="no-shadow"
                  hide-underline
                  inverted-light
                  :color="inputBgColor"
                  filter
                  autofocus-filter
                  :display-value="form.mnUsCongressionalDistricts.length ? `` : `Any / All`"
                />
              </q-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <q-btn
                color="primary"
                class="q-ma-md"
                push
                size="lg"
                @click="downloadExcel"
              >Download Export</q-btn>
              <q-btn
                color="secondary"
                class="q-ma-md"
                push
                size="lg"
                @click="clearForm"
              >Clear Form</q-btn>
            </div>
            <!-- <div name="goback">
              <q-btn @click="modal = false" color="negative" full class="q-mt-lg">Cancel / Close</q-btn>
            </div>-->
          </div>
        </div>
        <q-inner-loading :visible="loading"></q-inner-loading>
      </form>
    </div>
  </div>
</template>

<script>
import colors from '../../mixins/colors'
// import VeeValidate from 'vee-validate'

// $this.use(VeeValidate)

export default {
  name: 'CompanyExport',
  inject: ['$validator'],
  mixins: [colors],
  data () {
    return {
      loading: true,
      ready: false,
      form: {
        memberTypes: [],
        divisions: [],
        mnHouseDistricts: [],
        mnSenateDistricts: [],
        mnUsCongressionalDistricts: []
      },
      selectOptions: {
        memberTypes: [],
        divisions: [],
        mnHouseDistricts: [],
        mnSenateDistricts: [],
        mnUsCongressionalDistricts: [],
      },
      oData: {
        select: 'name,phoneNumber',
        include: 'Membership($expand=MembershipType($select=description)),' +
          'CompanyDivision($expand=Division($select=name)),' +
          'PrimaryPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),' +
          'MailingAddress($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),' +
          'Address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),' +
          'CompanyLocation($expand=Address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)))'
      }
    }
  },
  async created () {
    await this.getOptions()
    this.ready = true
    this.loading = false
  },
  computed: {
    copyClip () {
      return [
        {
          label: 'Copy to Clipboard',
          icon: 'file_copy',
          handler: () => {
            this.doCopy()
          }
        }
      ]
    }
  },
  methods: {
    clearForm () {
      let form = {
        memberTypes: [],
        divisions: [],
        mnHouseDistricts: [],
        mnSenateDistricts: [],
        mnUsCongressionalDistricts: []
      }
      this.$set(this, 'form', form)
    },
    async getOptions () {
      const { data } = await this.$axios.get('/api/company/export-filters')
      if (data) {
        this.$set(this.selectOptions, 'memberTypes', this.buildOptions(data.memberTypes))
        this.$set(this.selectOptions, 'divisions', this.buildOptions(data.divisions))
        this.$set(this.selectOptions, 'mnHouseDistricts', this.buildOptions(data.mnHouseDistricts, true))
        this.$set(this.selectOptions, 'mnSenateDistricts', this.buildOptions(data.mnSenateDistricts, true))
        this.$set(this.selectOptions, 'mnUsCongressionalDistricts', this.buildOptions(data.mnUsCongressionalDistricts, true))
      }
    },
    buildOptions (array, labelIsValue = false) {
      const entryArray = Object.entries(array).map((e) => ( { [e[0]]: e[1] } ));
      let returnArray = []
      for (const element of entryArray) {
        for (let obj in element) {
          if (element[obj]) {
            labelIsValue ? returnArray.push({label: element[obj], value: element[obj]}) : returnArray.push({label: element[obj], value: parseInt(obj)})
          }
        }
      }
      returnArray.sort(function(a, b) {
        var nameA = a.label.toString().toUpperCase(); // ignore upper and lowercase
        var nameB = b.label.toString().toUpperCase(); // ignore upper and lowercase
        if (!isNaN(nameA) && !isNaN(nameB)) {
          return nameA.localeCompare(nameB, undefined, {numeric: true, sensitivity: 'base'})
        } else {
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        }
      });
      // returnArray.unshift({label: '- Any/All -', value: null})
      return returnArray
    },
    buildFilters () {
      let filters = `Membership/isActive eq true AND removalDate eq null AND guestData ne true AND approved eq true`
      let addressCheck = false
      if (this.form.memberTypes && this.form.memberTypes.length) {
        for (let i = 0; i < this.form.memberTypes.length; i++) {
          if (i === 0) {
            filters = filters + ` AND (Membership/membershipTypeId eq ${this.form.memberTypes[i]}`
          } else {
            filters = filters + ` OR Membership/membershipTypeId eq ${this.form.memberTypes[i]}`
          }
        }
        filters = filters + `)`
      }
      if (this.form.divisions && this.form.divisions.length) {
        for (let i = 0; i < this.form.divisions.length; i++) {
          if (i === 0) {
            filters = filters + ` AND (companyDivision/any(a:a/divisionId eq ${this.form.divisions[i]})`
          } else {
            filters = filters + ` OR companyDivision/any(a:a/divisionId eq ${this.form.divisions[i]})`
          }
        }
        filters = filters + `)`
      }
      if (this.form.mnSenateDistricts && this.form.mnSenateDistricts.length) {
        addressCheck = true
        for (let i = 0; i < this.form.mnSenateDistricts.length; i++) {
          if (i === 0) {
            filters = filters + ` AND ((MailingAddress/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          } else {
            filters = filters + ` OR (MailingAddress/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/stateSenateDistrict eq '${this.form.mnSenateDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          }
        }
        filters = filters + `)`
      }
      if (this.form.mnHouseDistricts && this.form.mnHouseDistricts.length) {
        addressCheck = true
        for (let i = 0; i < this.form.mnHouseDistricts.length; i++) {
          // We have 3 addresses to look at:
          // 1: MailingAddress
          // 2: Address
          // 3: CompanyLocation/Address
          if (i === 0) {
            filters = filters + ` AND ((MailingAddress/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          } else {
            filters = filters + ` OR (MailingAddress/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/stateHouseDistrict eq '${this.form.mnHouseDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          }
        }
        filters = filters + `)`
      }
      if (this.form.mnUsCongressionalDistricts && this.form.mnUsCongressionalDistricts.length) {
        addressCheck = true
        for (let i = 0; i < this.form.mnUsCongressionalDistricts.length; i++) {
          if (i === 0) {
            filters = filters + ` AND ((MailingAddress/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          } else {
            filters = filters + ` OR (MailingAddress/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}' AND MailingAddress/removalDate eq null)`
            filters = filters + ` OR (Address/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}' AND Address/removalDate eq null)`
            filters = filters + ` OR (companyLocation/any(a:a/Address/federalHouseDistrict eq '${this.form.mnUsCongressionalDistricts[i]}') AND companyLocation/any(a:a/Address/removalDate eq null))`
          }
        }
        filters = filters + `)`
      }
      // if (addressCheck) {
      //   filters = filters + ` AND MailingAddress/removalDate eq null AND Address/removalDate eq null AND companyLocation/any(a:a/Address/removalDate eq null)`
      // }
      console.log('filters', filters)
      return filters
    },
    async downloadExcel () {
      const BASE_URL = process.env.API_BASE_URL
      const token = this.$store.getters['auth/token']
      // const endpoint = '/api/company/full-export'
      // const fullUrl = `${BASE_URL}${endpoint}?token=${token}&memberTypes=${this.form.memberType}&divisions=${this.form.division}&mnHouseDistricts=${this.form.mnHouseDistrict}&mnSenateDistricts=${this.form.mnSenateDistrict}&mnUsCongressionalDistricts=${this.form.mnUsCongressionalDistrict}`
      // contains(name,'acme') and
      const endpoint = `/api/odata/company/addressexcel?$expand=${this.oData.include}&$filter=${this.buildFilters()}&$orderby=Name`
      const fullUrl = `${BASE_URL}${endpoint}&token=${token}`
      // console.log('BASE_URL', BASE_URL)
      // console.log('token', token)
      // console.log('endpoint', endpoint)
      console.log('fullUrl', fullUrl)
      this.$download(fullUrl)
      // http://localhost:5000/api/odata/company/prettyexcel?$expand=Membership($select=isActive,yearJoined;$expand=MembershipType($select=description)),Membership($expand=MembershipPeriod($select=registrationDate,expiryDate,dropDate,notes)),AffiliateType($select=name),CompanyWorkType($expand=WorkType($select=description)),CompanyDivision($expand=Division($select=name,description)),CompanyProductService($expand=ProductService($select=name)),CompanySupplyProvideService($expand=SupplyProvideService($select=name)),PrimaryPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),MailingAddress($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),Address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),BillingPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),SafetyPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),HrPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),MarketingPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),CounselPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),BusinessDevPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),EstimatorPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),Estimator2Person($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),ProjectManagerPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),ProjectManager2Person($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),LaborPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),Comment($select=commentText,lastUpdate)&$select=name,phoneNumber,faxNumber,url,artba,unionStatus,minorityWomanVeteranBusiness,agcaIdentifier,cafIpfValue,cafIpfYear,chaseLevel,chaseLevel3Value,chaseLevel3Year,leadershipBlueprint,contractAccess,contractExpiration,directoryNameTitle,profile&$filter=contains(name,'acme') and Membership/isActive eq true AND removalDate eq null AND guestData ne true AND approved eq true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkYXZlQGFmaXhpYS5jb20iLCJqdGkiOiJiYWJkYzdkNy1mOGZlLTQ0YTAtYjEwOS0zYzQ3ZjFkNDc3MGMiLCJleHAiOjE1OTUwMTEzNDcsImlzcyI6Imh0dHBzOi8vc2VjdXJlLmFnY21uLm9yZyIsImF1ZCI6Imh0dHBzOi8vc2VjdXJlLmFnY21uLm9yZyJ9.2l7vvUQWx98v0V98wOD6K8_jVzAdGvbsRR2cEMpc25k

      // http://localhost:5000/api/odata/company/addressexcel?$expand=Membership($select=isActive,yearJoined;$expand=MembershipType($select=description)),CompanyDivision($expand=Division($select=name,description)),PrimaryPerson($select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender),MailingAddress($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),Address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)),CompanyLocation($expand=Address($select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)))&$filter=contains(name,%27acme%27)&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkYXZlQGFmaXhpYS5jb20iLCJqdGkiOiJiYWJkYzdkNy1mOGZlLTQ0YTAtYjEwOS0zYzQ3ZjFkNDc3MGMiLCJleHAiOjE1OTUwMTEzNDcsImlzcyI6Imh0dHBzOi8vc2VjdXJlLmFnY21uLm9yZyIsImF1ZCI6Imh0dHBzOi8vc2VjdXJlLmFnY21uLm9yZyJ9.2l7vvUQWx98v0V98wOD6K8_jVzAdGvbsRR2cEMpc25k

      // const { data } = await this.$axios.get(fullUrl)
      // if (data) {
      //   console.log('data', data)
      // }
    }
  }
}
</script>

<style scoped>
</style>
